import {MuWidget} from "mu-widget/lib/MuWidget";
import {getSelectedValue, setSelectedValue} from "../Utils";

export class UiDateFilter extends MuWidget<MuWidget, {

}>
{
	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`
		<div>
			<label class="radio-inline">
				<input type="radio" mu-name="type" mu-id="type_null" mu-change="type_change" value="null">neomezeno
			</label>
			<label class="radio-inline">
				<input type="radio" mu-name="type" mu-id="type_abs" mu-change="type_change" value="abs">datum od-do
			</label>
			<label class="radio-inline">
				<input type="radio" mu-name="type" mu-id="type_rel" mu-change="type_change" value="rel">dny od-do
			</label>
		</div>
		<div class="form-inline" mu-id="controls_abs">
  			<div class="form-group">
    			<label mu-for="absFrom">Datum od</label>
    			<input type="date" class="form-control" mu-id="absFrom">
  			</div>
  			<div class="form-group">
    			<label mu-for="absTo">do</label>
    			<input type="date" class="form-control" mu-id="absTo">
  			</div>
		</div>
		<div class="form-inline" mu-id="controls_rel">
  			<div class="form-group">
    			<label mu-for="relFrom">Před</label>
    			<input type="number" class="form-control" mu-id="relFrom">
    			<label mu-for="relFrom">dny</label>
  			</div>
  			<div class="form-group">
    			<label mu-for="relTo">za</label>
    			<input type="number" class="form-control" mu-id="relTo">
    			<label mu-for="relTo">dnů</label>
  			</div>
		</div>
		`)
	}

	private allTypes :DateFilterType[] = ["rel", "abs", "null"];
	public getType(): DateFilterType
	{
		// @ts-ignore
		return getSelectedValue(this.ui.type_null) || "null";
		/* for(const t of this.allTypes) {
			if (this.ui["type_" + t].checked) {
				return t;
			}
		}
		return "null"; */
	}

	public setType(type: DateFilterType, changeRadio = true): void
	{
		for(const t of this.allTypes) {
			if (this.ui['controls_' + t]) {
				this.muVisible(t == type, 'controls_' + t);
			}
		}
		setSelectedValue(this.ui.type_null, type);
	}

	type_change() {
		this.setType(this.getType(), false);
	}

	afterIndex() {
		this.type_change();
	}

	muFetchData(): any {
		const res: any = {
			type: this.getType()
		};

		switch (res.type) {
			case "null": return null;
			case "abs":
				res.dtFrom = this.ui.absFrom.value;
				res.dtTo = this.ui.absTo.value;
				break;
			case "rel":
				res.dayFrom = this.ui.relFrom.value;
				res.dayTo = this.ui.relTo.value;
				break;
		}

		return res;
	}

	muBindData(srcData: any) {
		if (srcData) {
			this.setType(srcData.type);
			switch (srcData.type) {
				case "abs":
					this.ui.absFrom.value = srcData.dtFrom;
					this.ui.absTo.value = srcData.dtTo;
					break;
				case "rel":
					this.ui.relFrom.value = srcData.dayFrom;
					this.ui.relTo.value = srcData.dayTo;
					break;
			}

		} else this.setType("null");
	}
}

export type DateFilterType = "rel"|"abs"|"null";

export type DateFilterValue = null|{
	type: DateFilterType,
	dtFrom?: string,
	dtTo?: string,
	dayFrom?: string,
	dayTo?: string,
};